import React, { useRef } from 'react';
import { Footer } from '@everlywell/leaves';

import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { useScrolledIntoViewOnce } from 'utils/hooks';
import { handleIterableSubscription } from 'utils/iterableSubscribe';

const FooterContainer = () => {
  const footerRef = useRef<HTMLDivElement>(null);

  const trackScrolledIntoView = () => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.SCROLLED_TO_BOTTOM,
      data: {
        label: ANALYTICS.LABELS.HOMEPAGE,
      },
    });
  };

  useScrolledIntoViewOnce(trackScrolledIntoView, footerRef);

  const handleSubscribeSubmit = ({
    subscribeEmail,
  }: {
    [key: string]: string;
  }) => {
    handleIterableSubscription(subscribeEmail);
  };

  return (
    <div ref={footerRef}>
      <Footer onSubscribeSubmit={handleSubscribeSubmit} />
    </div>
  );
};

export default FooterContainer;
